export const FLOW_DOCTOR = 'Flow Doctor';
export const TIMESTAMP_FORMAT = 'MMMM D, YYYY h:mm:ss A z';
export const TIMESTAMP_PRECISE_FORMAT = 'MMMM D, YYYY h:mm:ss.SSS A z';
export const TIMESTAMP_SHORTHAND_FORMAT = 'M/D/YY H:mm:ss';
export const TIMESTAMP_TIME_FORMAT = 'h:mm:ss A z';
export const TIMESTAMP_DATE_FORMAT = 'MMMM D, YYYY';